import { Stack } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TextFieldFilter, TextFieldFilterProps } from '@cnx-saas/common-fe';
import { UserFilters } from '@cnx-saas/common';

export const InvitedFilters = ({ emailProps }: TableFiltersProps) => {
  return (
    <Stack flexDirection="row" gap={2} mt={3} gridArea="filters">
      <TextFieldFilter {...emailProps} />
    </Stack>
  );
};

export interface TableFiltersProps {
  emailProps: TextFieldFilterProps;
}

export function useFilters() {
  const { t } = useTranslation();

  const [email, setEmail] = React.useState('');
  const emailProps = React.useMemo<TextFieldFilterProps>(
    () => ({
      value: email,
      placeholder: t('userManagement.label.email', {
        defaultValue: 'Email',
      }),
      onChange: setEmail,
    }),
    [t, email],
  );

  const userFilters = useMemo(() => {
    const filter: UserFilters = {};

    if (email) {
      filter.email = email;
    }

    return filter;
  }, [email]);

  function clearAllFilters() {
    setEmail('');
  }

  return {
    userFilters,
    clearAllFilters,
    filtersActive: Object.keys(userFilters).length > 0,
    emailProps,
  };
}
